'use client';

import type { ContentBlock, WithStreamingMetadata } from '@tinct/core-api-models';
import type { AiChatPlugin, AiChatPluginContext } from '../types';
import { PreviewWebsiteContent } from './preview-website-content';

/**
 * Plugin for rendering preview_website content blocks.
 *
 * Handles the 'preview_website' block type and renders a website preview card
 * with image, title, and description.
 */
export const previewWebsitePlugin: AiChatPlugin<'preview_website'> = {
  id: 'preview-website',
  blockTypes: ['preview_website'],
  priority: 15,

  render(state: WithStreamingMetadata<ContentBlock>, _ctx: AiChatPluginContext) {
    if (state.type !== 'preview_website') {
      return null;
    }

    return (
      <PreviewWebsiteContent
        key={`preview-website-${state.index}`}
        title={state.title}
        description={state.description}
        previewImageUrl={state.previewImageUrl}
        notice={state.notice}
      />
    );
  },
};
